<script setup>
import { OverlayCard, Grid } from 'digitalpower';
import { clientes } from "@/data";

function go(cliente) {
  let $a = document.createElement('a');
  $a.href = cliente?.url;
  $a.target = '_blank';
  document.body.appendChild($a);
  $a.click();
  $a.remove();
}
</script>
<template>
  <section id="clientes">
    <div class="clientes-header text-center">
      <h2>Casos de Éxito</h2>
      <p>Explora algunos de los proyectos y clientes que han confiado en nosotros.</p>
    </div>

    <div class="grid-wrapper">
      <Grid class="grid-container" width="320" gapped>
        <OverlayCard shadow v-for="(cliente, key) in clientes" :key="key" class="oCard" :text="cliente?.text"
          :img="cliente?.image" @click="go(cliente)" />
      </Grid>
    </div>
  </section>
</template>

<style scoped lang="scss">
#clientes {
  width: 100%;
  padding: 6rem 2rem;
  background: white;
}

.clientes-header {
  margin-bottom: 4rem;

  h2 {
    font-size: 2.5rem;
    color: var(--text-main);
    margin-bottom: 1rem !important;

    width: 100%;
  }

  p {
    width: 100%;
    font-size: 1.1rem;
    color: var(--text-muted);
  }
}

.grid-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.grid-container {
  gap: 2rem !important;
  justify-content: center;
}

.oCard {
  width: 100% !important;
  max-width: 380px;
  height: 200px !important;
  border-radius: 16px !important;
  overflow: hidden;
  cursor: pointer;
  transition: all var(--duration);
  border: 1px solid rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
  }
}

@media screen and (max-width: 768px) {
  #clientes {
    padding: 4rem 1rem;
  }

  .oCard {
    height: 180px !important;
  }
}
</style>